let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("116Fh")).then(() => parcelRequire('6kY1Z'));